import { render, staticRenderFns } from "./PartnerBoxesContainer.vue?vue&type=template&id=e0176a96&scoped=true"
import script from "./PartnerBoxesContainer.vue?vue&type=script&lang=js"
export * from "./PartnerBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./PartnerBoxesContainer.vue?vue&type=style&index=0&id=e0176a96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0176a96",
  null
  
)

export default component.exports